(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chat-button"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chat-float')) {
    class ChatFloat extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.chat-float__panel');
        this.toggle = this.querySelector('[data-chat-toggle]');
        if (!this.panel || !this.toggle) return;

        this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden));

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.panel.hidden) {
            this.setOpen(false);
            this.toggle.focus();
          }
        });

        // Close the panel when clicking anywhere else on the page
        document.addEventListener('click', (event) => {
          if (!this.panel.hidden && !this.contains(event.target)) this.setOpen(false);
        });

        this.querySelectorAll('[data-channel]').forEach((link) =>
          link.addEventListener('click', () => this.track(link.dataset.channel))
        );
      }

      setOpen(open) {
        this.panel.hidden = !open;
        this.toggle.setAttribute('aria-expanded', open);
      }

      // Records a "contact_click" event (with the channel) for Shopify Customer events and Google Analytics
      track(channel) {
        const data = { channel, page: window.location.pathname };
        try {
          window.Shopify?.analytics?.publish?.('contact_click', data);
        } catch (error) {}
        if (typeof window.gtag === 'function') window.gtag('event', 'contact_click', data);
      }
    }
    customElements.define('chat-float', ChatFloat);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-carousel"] && !Shopify.designMode) return;
  try {
    
  function initReelsSection(section) {
    var stage = section.querySelector('.reels-stage');
    if (!stage) return;

    var wrapper = section.querySelector('.reels-section__wrapper');
    var cards = Array.prototype.slice.call(stage.querySelectorAll('.reel-card'));
    if (!cards.length) return;

    var infoLinks = Array.prototype.slice.call(section.querySelectorAll('.reel-card__info'));
    var prevBtn = section.querySelector('.reels-nav--prev');
    var nextBtn = section.querySelector('.reels-nav--next');
    var active = Math.floor((cards.length - 1) / 2);

    function render() {
      var half = cards.length / 2;
      cards.forEach(function (card, i) {
        var diff = i - active;
        if (diff > half) diff -= cards.length;
        if (diff < -half) diff += cards.length;
        var absDiff = Math.abs(diff);

        card.style.transform = 'translateX(' + (diff * 180) + 'px) scale(' + Math.max(1 - absDiff * 0.18, 0.5) + ')';
        card.style.filter = 'blur(' + (absDiff === 0 ? 0 : absDiff * 2) + 'px)';
        card.style.opacity = absDiff > 2 ? 0 : 1 - absDiff * 0.25;
        card.style.zIndex = 10 - absDiff;
      });
      infoLinks.forEach(function (link) {
        link.style.display = link.dataset.infoIndex == active ? 'block' : 'none';
      });
    }

    function goNext() { active = (active + 1) % cards.length; render(); }
    function goPrev() { active = (active - 1 + cards.length) % cards.length; render(); }

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () { active = i; render(); });
    });

    section.querySelectorAll('.reel-card__mute').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var video = btn.closest('.reel-card__media').querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        btn.textContent = video.muted ? '🔇' : '🔊';
      });
    });

    var touchStartX = 0;
    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    wrapper.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { diff > 0 ? goNext() : goPrev(); }
    }, { passive: true });

    var wheelLocked = false;
    wrapper.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      if (wheelLocked) return;
      if (e.deltaX > 15) { goNext(); wheelLocked = true; }
      else if (e.deltaX < -15) { goPrev(); wheelLocked = true; }
      if (wheelLocked) setTimeout(function () { wheelLocked = false; }, 350);
    }, { passive: false });

    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.reels-section').forEach(initReelsSection);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.reels-section');
    if (section) initReelsSection(section);
  });

  } catch(e) { console.error(e); }
})();
})();
